import DashboardExportApi from "../api/DashboardExportApi";
import { DashboardExportInputValues } from "../types/model";

export const getDashboardExport = (values: DashboardExportInputValues[]) => {
    return DashboardExportApi.getDashboardExport(values);
}

export const getDashboardExportByXlsx = (value: File) => {
    return DashboardExportApi.getDashboardExportxlsx(value);
}